// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd3ca11d","667":"ad687cc7","977":"57bec574"}[chunkId] + ".chunk.js";
};